const SectionTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="mb-6">
    <h2 className="text-[24px] font-medium text-dark-blue font-primary mb-2">
      {children}
    </h2>
    <div className="w-10 h-[3px] bg-[#3b519c] rounded-sm" />
  </div>
);

export default SectionTitle;
